<template>
  <div class="tpage">
    <div class="topbar">
      <div class="who">
        <span class="hello">您好，{{ name || '老师' }}</span>
        <span class="muted" v-if="departments.length">{{ departments.join(' / ') }}</span>
      </div>
      <div class="ops">
        <el-button type="text" class="op" @click="pwdVisible = true">修改密码</el-button>
        <el-button type="text" class="op" @click="logout">退出</el-button>
      </div>
    </div>

    <div class="body">
      <div class="grid">
        <div class="grid-item" v-for="item in menus" :key="item.text" @click="open(item)">
          <i :class="item.icon"></i>
          <span>{{ item.text }}</span>
          <em v-if="!item.ready" class="soon">迁移中</em>
        </div>
      </div>
    </div>

    <el-dialog title="修改密码" :visible.sync="pwdVisible" width="90%" custom-class="pwd-dialog">
      <el-form @submit.native.prevent>
        <el-form-item>
          <el-input v-model="pwdForm.old" type="password" show-password placeholder="原密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="pwdForm.newPwd" type="password" show-password placeholder="新密码（至少 6 位）"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="pwdForm.confirm" type="password" show-password placeholder="确认新密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="pwdVisible = false">取消</el-button>
        <el-button type="primary" :loading="pwdSaving" @click="savePwd">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { teacherProfile, teacherChangePwd, getTeacherLogin, clearTeacherLogin } from '@/api/teacher.js'

export default {
  name: 'TeacherHome',
  data() {
    return {
      name: '',
      departments: [],
      pwdVisible: false,
      pwdSaving: false,
      pwdForm: { old: '', newPwd: '', confirm: '' },
      menus: [
        { text: '教务管理', icon: 'el-icon-s-management', path: '/tedu', ready: true },
        { text: '一生一档', icon: 'el-icon-folder-opened', path: '', ready: false },
        { text: '消息通知', icon: 'el-icon-bell', path: '/tedu-notice', ready: true }
      ]
    }
  },
  mounted() {
    const info = getTeacherLogin()
    if (!info.token) {
      this.$router.replace('/tlogin')
      return
    }
    this.name = info.name || ''
    this.loadProfile()
  },
  methods: {
    loadProfile() {
      teacherProfile()
        .then((res) => {
          if (res.code === 401) {
            this.logout()
            return
          }
          if (res.code === 0 && res.data) {
            this.name = res.data.name || this.name
            this.departments = res.data.departments || []
          }
        })
        .catch(() => {})
    },
    open(item) {
      if (!item.ready) {
        this.$message.info('该功能网页端暂未开放，请稍后再试')
        return
      }
      this.$router.push(item.path)
    },
    savePwd() {
      if (!this.pwdForm.old) {
        this.$message.warning('请输入原密码')
        return
      }
      if (!this.pwdForm.newPwd || this.pwdForm.newPwd.length < 6) {
        this.$message.warning('新密码至少 6 位')
        return
      }
      if (this.pwdForm.newPwd !== this.pwdForm.confirm) {
        this.$message.warning('两次输入的新密码不一致')
        return
      }
      this.pwdSaving = true
      teacherChangePwd({ old_password: this.pwdForm.old, new_password: this.pwdForm.newPwd })
        .then((res) => {
          this.pwdSaving = false
          if (res.code !== 0) {
            this.$message.error(res.msg || '修改失败')
            return
          }
          this.$message.success('密码修改成功，请重新登录')
          this.pwdVisible = false
          this.logout()
        })
        .catch(() => {
          this.pwdSaving = false
          this.$message.error('网络异常，请稍后重试')
        })
    },
    logout() {
      clearTeacherLogin()
      this.$router.replace('/tlogin')
    }
  }
}
</script>

<style scoped lang="scss">
.tpage {
  min-height: 100vh;
  background: #f4f6fb;
}
.topbar {
  background: #fff;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eef1f7;
}
.who {
  display: flex;
  flex-direction: column;
  .hello {
    font-size: 16px;
    color: #1f2d3d;
    font-weight: 600;
  }
  .muted {
    margin-top: 2px;
    font-size: 12px;
    color: #8a94a6;
  }
}
.ops .op {
  padding: 0 4px;
  font-size: 13px;
}
.body {
  padding: 16px;
}
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.grid-item {
  position: relative;
  background: #fff;
  border-radius: 10px;
  padding: 18px 6px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(31, 45, 61, 0.05);

  i {
    font-size: 26px;
    color: #3b6ef0;
  }
  span {
    font-size: 13px;
    color: #38445a;
  }
  .soon {
    position: absolute;
    top: 6px;
    right: 6px;
    font-size: 10px;
    font-style: normal;
    color: #b0b8c8;
    background: #f4f6fb;
    border-radius: 8px;
    padding: 1px 5px;
  }
  &:active {
    transform: scale(0.98);
  }
}
</style>
